var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPositive({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "SVG",
    clipPath: "url(#clip0_4001_9277)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M4.66634 7.33334L7.33301 1.33334C7.86344 1.33334 8.37215 1.54406 8.74722 1.91913C9.12229 2.2942 9.33301 2.80291 9.33301 3.33334V6.00001H13.1063C13.2996 5.99782 13.4911 6.03768 13.6674 6.11682C13.8437 6.19596 14.0008 6.3125 14.1276 6.45835C14.2544 6.60421 14.348 6.77589 14.4019 6.96151C14.4558 7.14713 14.4687 7.34225 14.4397 7.53334L13.5197 13.5333C13.4715 13.8513 13.31 14.1411 13.0649 14.3493C12.8199 14.5576 12.5079 14.6703 12.1863 14.6667H4.66634M4.66634 7.33334V14.6667M4.66634 7.33334H2.66634C2.31272 7.33334 1.97358 7.47382 1.72353 7.72387C1.47348 7.97392 1.33301 8.31306 1.33301 8.66668V13.3333C1.33301 13.687 1.47348 14.0261 1.72353 14.2762C1.97358 14.5262 2.31272 14.6667 2.66634 14.6667H4.66634",
    stroke: "#ACACBE",
    strokeWidth: 1.33333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4001_9277"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPositive);
export default __webpack_public_path__ + "static/media/positive.1a1636fecb8b9670df61a3a7cca55e68.svg";
export { ForwardRef as ReactComponent };